import type { ReactNode } from 'react';
import { cn } from '@frontdoor/ui/lib/utils';

type DetailFieldProps = {
  label: string;
  children: ReactNode;
  showDivider?: boolean;
  className?: string;
};

export function DetailField({ label, children, showDivider = true, className }: DetailFieldProps) {
  return (
    <div className={cn(showDivider && 'border-b border-border pb-4', className)}>
      <dt className="text-sm font-medium">{label}</dt>
      <dd className="mt-1 text-sm">{children}</dd>
    </div>
  );
}
